const APP_ENV = process.env.NEXT_PUBLIC_APP_ENV || 'local';
const defaultEmailUrl = APP_ENV === 'local' ? 'http://localhost:2000' : 'https://app.nordit.hr';

const ENV_VARIABLES = {
  APP_ENV,
  NODE_ENV: process.env.NODE_ENV || 'production',
  GRAPHQL_URL: 'https://content.nordit.co/graphql',
  EMAIL_URL: process.env.EMAIL_URL || defaultEmailUrl,
};

export { ENV_VARIABLES };
